import React from 'react';
import { isThresholdRule } from 'flow/service/rules';
import type { RuleBuilderRule } from 'flow/service/rules';
import Threshold from './Threshold';
import Group from './Group';

type RuleProps = {
  rule: RuleBuilderRule;
};

/*
* Top level controller for group and threshold nodes
*/
export default function Rule({ rule }: RuleProps) {
  if (isThresholdRule(rule)) {
    return <Threshold rule={rule} />;
  }
  return <Group rule={rule} RuleWrapper={Rule} />;
}
